module.exports = __webpack_public_path__ + "img/start.fad5e501.svg";